import projectData from './project-data';
import {TranslatorFunction} from '../../gui-config';


import popWav from '!arraybuffer-loader!./83a9787d4cb6f3b7632b4ddfebf74367.wav?';
import backdrop from '!arraybuffer-loader!./a9ab7960e5cad6caa8315bd0cfeb1038.png?';
import costume0 from '!arraybuffer-loader!./9d2b256728417f57326ed57b64f7630b.png?';
import costume1 from '!arraybuffer-loader!./72c5d407857b80713db8866cc4800907.png?';
import costume2 from '!arraybuffer-loader!./d3143ea5f5a92a60b395b41d9d3962ca.png?';
import costume3 from '!arraybuffer-loader!./d95d61950df469a156d08e1567cc3ff4.png?';
import costume4 from '!arraybuffer-loader!./2b14d11e67b245134e4c8401414262a9.png?';
import costume5 from '!arraybuffer-loader!./ec6c51344446b92e4fc1fb490c56c3ed.png?';


declare function require (path: 'fastestsmallesttextencoderdecoder'): {TextEncoder: typeof TextEncoder};

const defaultProject = (translator?: TranslatorFunction) => {
    let _TextEncoder: typeof TextEncoder;
    if (typeof TextEncoder === 'undefined') {
        _TextEncoder = require('fastestsmallesttextencoderdecoder').TextEncoder;
    } else {
        _TextEncoder = TextEncoder;
    }
    const encoder = new _TextEncoder();

    const projectJson = projectData(translator);
    return [{
        // TODO: This is weird - the ids are annotated by scratch-storage to be strigns, but
        //       this one is an int. May have implications on checking with `!` and in conditions,
        //       so leaving it as is for now.
        id: 0,
        assetType: 'Project',
        dataFormat: 'JSON',
        data: JSON.stringify(projectJson)
    }, {
        id: '83a9787d4cb6f3b7632b4ddfebf74367',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(popWav)
    }, {
        id: 'a9ab7960e5cad6caa8315bd0cfeb1038',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(backdrop)
    }, {
        id: '9d2b256728417f57326ed57b64f7630b',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume0)
    }, {
        id: '72c5d407857b80713db8866cc4800907',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume1)
    }, {
        id: 'd3143ea5f5a92a60b395b41d9d3962ca',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume2)
    }, {
        id: 'd95d61950df469a156d08e1567cc3ff4',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume3)
    }, {
        id: '2b14d11e67b245134e4c8401414262a9',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume4)
    }, {
        id: 'ec6c51344446b92e4fc1fb490c56c3ed',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume5)
    }];
};

export default defaultProject;
